import { Button, Card, Container, Stack, Typography, Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { getPosts } from "../../api/posts";
import { isLoggedIn } from "../../helpers/authHelper";
import CreatePost from "../CreatePost";
import GridLayout from "../GridLayout";
import Loading from "../Loading";
import Navbar from "../Navbar";
import SortBySelect from "../SortBySelect";
import PostCard from "../PostCard";
import Sidebar from "../Sidebar";
import HorizontalStack from "../util/HorizontalStack";
import PostBrowser from "../PostBrowser";
import WelcomeBanner from "../WelcomeBanner";

const ExploreView = () => {
  const user = isLoggedIn();
  
  return (
    <Box sx={{ backgroundColor: "#F5F5F5", minHeight: "100vh" }}>
      <Navbar />
      <Container maxWidth="lg" sx={{ py: 4 }}>
        {/* Show WelcomeBanner at top when not logged in */}
        {!user && (
          <Box sx={{ mb: 4 }}>
            <WelcomeBanner />
          </Box>
        )}
        <GridLayout
          left={<PostBrowser createPost contentType="posts" />}
          right={<Sidebar />}
        />
      </Container>
    </Box>
  );
};

export default ExploreView;
